declare global {
  interface Window {
    fathom?: {
      trackEvent: (name: string, options?: { _value: number }) => void;
    };
  }
}

export function trackFathomEvent(name: string, value?: number) {
  if (!window.fathom) {
    console.warn('Fathom is not initialized!', name, value);
    return;
  } else if (value) {
    window.fathom.trackEvent(name, { _value: value });
  } else {
    window.fathom.trackEvent(name);
  }
}
